import BaseIcon from './base-icon';

class ResetIcon extends BaseIcon {
  renderSVG(): string {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" stroke-width="2" viewBox="0 0 24 24" fill="none">
        <path
          d="M2.8321 8C4.3754 4.4682 7.8994 2 12 2C17.1854 2 21.449 5.9467 21.9507 11"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.9507 11C21.449 15.9467 17.1854 20 12 20C7.8994 20 4.3754 17.5318 2.8321 14"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 8H2.6C2.2686 8 2 7.7314 2 7.4V3"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;
  }
}

customElements.define('reset-icon', ResetIcon);
